import { render, staticRenderFns } from "./ProductionLineDetails.vue?vue&type=template&id=fb55e610&scoped=true&"
import script from "./ProductionLineDetails.vue?vue&type=script&lang=js&"
export * from "./ProductionLineDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductionLineDetails.vue?vue&type=style&index=0&id=fb55e610&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb55e610",
  null
  
)

export default component.exports